import { Card, Copyable, OrderList, Text } from "../../../../components";
import Localization from "../../../../localization";
import { Constants } from "../../../../utils";
import React from "react";

const instructions = [
  {
    text: Localization.service_verisure.step_1,
    list: [
      Localization.formatString(
        Localization.service_verisure.step_1_1,
        Constants.Project.phones.support
      ),
      Localization.service_verisure.step_1_2,
    ],
  },
  {
    text: Localization.service_verisure.step_2,
    list: [Localization.service_verisure.step_2_1],
  },
];

const Verisure = ({ alarmModel }) => {
  const renderOrderList = ({ text, list = [] }, index = 0) => {
    return (
      <React.Fragment>
        <Text
          level={5}
          weight={700}
          className="m-35-t"
          children={`${index + 1}. ${text}`}
        />
        <OrderList className="m-10-t" prefix="bullet" items={list} />
      </React.Fragment>
    );
  };
  return (
    <div>
      <Text color="secondary" children={Localization.service_verisure.desc} />
      {React.Children.toArray(instructions.map(renderOrderList))}
      <Card
        bordered
        className="m-15-t"
        title={`#${alarmModel.identifier}#`}
        extra={<Copyable level={3} children={`#${alarmModel.identifier}#`} />}
      />
    </div>
  );
};

export default Verisure;
